import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';
import SectionTitle from '@/components/base/SectionTitle';

export default function FeaturedGrid() {
  const featured = comics.filter((c) => c.isRecommended).slice(0, 4);

  return (
    <section id="featured" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <SectionTitle
          label="/ 编辑精选"
          title="无删减下拉式韩漫精选"
          highlight={['无删减', '下拉式']}
          align="center"
        />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {featured.slice(0, 1).map((comic) => (
            <Link
              key={comic.slug}
              to={`/comic/${comic.slug}`}
              className="group relative rounded-xl overflow-hidden lg:col-span-1 lg:row-span-2 cursor-pointer"
            >
              <div className="aspect-[3/4] lg:h-full">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  title={`${comic.title} - 韩国漫画`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="inline-block text-background-50 text-xs font-semibold bg-accent-500 px-3 py-1 rounded-md mb-3 font-label">本周强推</span>
                <h3 className="text-background-50 text-xl md:text-2xl font-bold">{comic.title}</h3>
                <p className="text-background-200 text-sm mt-2 line-clamp-2">{comic.description}</p>
                <div className="flex items-center gap-3 mt-3">
                  <span className="text-background-300 text-xs">{comic.author}</span>
                  <span className="text-amber-400 text-xs flex items-center gap-1">
                    <i className="ri-star-fill"></i>
                    {comic.rating}分
                  </span>
                </div>
              </div>
            </Link>
          ))}

          {featured.slice(1, 3).map((comic) => (
            <Link
              key={comic.slug}
              to={`/comic/${comic.slug}`}
              className="group relative rounded-xl overflow-hidden cursor-pointer"
            >
              <div className="aspect-[16/9]">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  title={`${comic.title} - 韩国漫画`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/30 to-transparent"></div>
              <div className="absolute bottom-0 left-0 p-4 md:p-5">
                <h3 className="text-background-50 text-lg font-bold">{comic.title}</h3>
                <p className="text-background-300 text-sm mt-1">{comic.author}</p>
              </div>
            </Link>
          ))}

          {featured.slice(3, 4).map((comic) => (
            <Link
              key={comic.slug}
              to={`/comic/${comic.slug}`}
              className="group relative rounded-xl overflow-hidden hidden lg:block cursor-pointer"
            >
              <div className="aspect-[16/9]">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  title={`${comic.title} - 韩国漫画`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/30 to-transparent"></div>
              <div className="absolute bottom-0 left-0 p-4 md:p-5">
                <h3 className="text-background-50 text-lg font-bold">{comic.title}</h3>
                <p className="text-background-300 text-sm mt-1">{comic.author}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}